/**
 * Get the two-letter ISO 639-1 code defined on the HTML element's `lang`
 * attribute, ignoring any country value.
 *
 * @param {string} [defaultLang] - Default to use in case the `lang` attribute
 *   isn't defined.
 * @returns {string}
 * @example
 *
 * // <html lang="en">
 * getDocumentLang()
 * // => 'en'
 *
 * // <html lang="en-US">
 * getDocumentLang()
 * // => 'en'
 *
 * // <html>
 * getDocumentLang()
 * // => undefined
 *
 * // <html>
 * getDocumentLang('en-US')
 * // => 'en'
 */
export function getDocumentLang(defaultLang) {
  return (
    (document.documentElement.lang || defaultLang || '').slice(0, 2) ||
    defaultLang
  );
}
